/* 事件总线，统一管理跨组件/ 跨上下文的事件通信（axios中401处理等） */
import mitt from "mitt";

// 定义事件类型
type Events = {
  'auth:expired': void; // token失效
  'auth:changed': void; // 权限更改
  'request:error': {
    status: number;
    error: string | undefined;
    errorDescription: string | undefined;
    error_description: string | undefined;
  }; // 请求错误
  'request:404': void; // 404错误
}

const eventBus = mitt<Events>();

export default eventBus;